// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export function computeHMACSHA256(_stringToSign: string, _accountKey: string): string {
  throw new Error("computeHMACSHA256 is not supported in the browser");
}
